import { faExternalLink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NewBasicModal as BasicModal } from 'aa_common/front-end'
import { Button, Checkbox } from 'aa_common/front-end/antd'
import { Typography } from 'antd'
import { MF_AI_AGREEMENT_URL } from 'common/constants'
import { getNs } from 'common/i18n-config'
import { useState } from 'react'

import { ModalContent } from '../styles'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form', 'common'])

type AIConsentModalProps = {
  isShow: boolean
  onHideModal: () => void
  onAgree: () => void
}

export const AIConsentModal = ({ isShow, onHideModal, onAgree }: AIConsentModalProps) => {
  useNsReady()
  const [doNotCooperate, setDoNotCooperate] = useState(false)

  return (
    <BasicModal
      title={t('start_using_service')}
      isShow={isShow}
      onCancel={onHideModal}
      footer={
        <>
          <Button color="grey" onClick={onHideModal}>
            {t('actions.cancel')}
          </Button>
          <Button color="blue" onClick={onAgree} disabled={doNotCooperate}>
            {t('agree_and_start')}
          </Button>
        </>
      }
    >
      <ModalContent>
        <Typography>{t('require_agreement_special_terms')}</Typography>
        <Typography.Link href={MF_AI_AGREEMENT_URL} target="_blank">
          {t('service_special_provisions')} <FontAwesomeIcon icon={faExternalLink} />
        </Typography.Link>
        <Typography>{t('training_data_opt_out_description')}</Typography>
        <Typography>{t('training_setting_change_anytime')}</Typography>
        <Checkbox
          name="do-not-cooperate"
          checked={doNotCooperate}
          onChange={({ checked }) => setDoNotCooperate(checked)}
        >
          {t('do_not_cooperate')}
        </Checkbox>
      </ModalContent>
    </BasicModal>
  )
}
